const ENTITIES_TYPES = {
    SYSTEM_PLAYLIST: 'SYSTEM_PLAYLIST',
    ARTIST: 'ARTIST',
    ALBUM: 'ALBUM',
    SONG: 'SONG',
    PLAYLIST: 'PLAYLIST',
    TRACK: 'TRACK',
    RADIO: 'RADIO',
    ARTIST_RADIO: 'ARTIST_RADIO',
    GENRE_RADIO: 'GENRE_RADIO'
};

module.exports = ENTITIES_TYPES;



// WEBPACK FOOTER //
// ./src/containers/Music/EntityType.js